// クライアント（遷移元のプロダクト）の設定
// サーバ側で定義すべき値もありますが、現在はハードコードしています

export type ClientSetting = {
  id: ClientIds
  productName: string
}

export type ClientIds =
  | 'default'
  | 'momo'
  | 'curon-clinic-web'
  | 'id-clinic'
  | 'clinic-insight'
  | 'poc-client'

export const clientSettings: Record<ClientIds, ClientSetting> = {
  default: {
    id: 'default',
    productName: '__NAME__',
  },
  momo: {
    id: 'momo',
    productName: 'MOMO',
  },
  'curon-clinic-web': {
    id: 'curon-clinic-web',
    productName: 'CuronClinicWeb',
  },
  'id-clinic': {
    id: 'id-clinic',
    productName: 'IdClinic',
  },
  'clinic-insight': {
    id: 'clinic-insight',
    productName: 'ClinicInsight',
  },
  'poc-client': {
    id: 'poc-client',
    productName: 'PocClient',
  },
}

const COOKIE_LOGIN_CLIENT_ID_MOMO = 'momo'
const COOKIE_LOGIN_CLIENT_ID_CURON_CLINIC_WEB = 'curon-clinic-web'
const COOKIE_LOGIN_CLIENT_ID_ID_CLINIC = 'id-clinic'
const COOKIE_LOGIN_CLIENT_ID_CLINIC_INSIGHT = 'clinic-insight'
const COOKIE_LOGIN_CLIENT_ID_POC_CLIENT = 'poc-client'

export const getClientSettingByCookieLoginClientId = (clientId: string) => {
  if (clientId === COOKIE_LOGIN_CLIENT_ID_MOMO) {
    return clientSettings.momo
  }
  if (clientId === COOKIE_LOGIN_CLIENT_ID_CURON_CLINIC_WEB) {
    return clientSettings['curon-clinic-web']
  }
  if (clientId === COOKIE_LOGIN_CLIENT_ID_ID_CLINIC) {
    return clientSettings['id-clinic']
  }
  if (clientId === COOKIE_LOGIN_CLIENT_ID_CLINIC_INSIGHT) {
    return clientSettings['clinic-insight']
  }
  if (clientId === COOKIE_LOGIN_CLIENT_ID_POC_CLIENT) {
    return clientSettings['poc-client']
  }

  return null
}

export const getHeadMetaTitle = (clientId: ClientIds) => {
  switch (clientId) {
    case 'momo':
      return 'クロンスマートパス'
    case 'curon-clinic-web':
      return 'クロンオンライン診療'
    case 'id-clinic':
    default:
      return 'curon（クロン）'
  }
}
